import { BagelVue, RouterWrapper } from '@bagelink/vue'

export const bloxSite = {
	modules: import.meta.glob('./components/blocks/*.vue', { eager: true }),
	websiteName: 'shalva',
	store: 'shalva',
	locale: 'en',
	supportedLocales: ['en'],
	plugins: [[BagelVue, {}]],
	globalComponents: { RouterWrapper },
}
import EventNav from './components/blocks/EventNav.vue'
import EventHero from './components/blocks/EventHero.vue'
import EventAbout from './components/blocks/EventAbout.vue'
import EventFooter from './components/blocks/EventFooter.vue'
import EventPeople from './components/blocks/EventPeople.vue'
import EventNames from './components/blocks/EventNames.vue'
import EventMedia from './components/blocks/EventMedia.vue'
import EventGallery from './components/blocks/EventGallery.vue'
import EventJournal from './components/blocks/EventJournal.vue'
import EventRegistration from './components/blocks/EventRegistration.vue'
import Spacer from './components/blocks/Spacer.vue'

const thumb = (name: string) => `/block-thumbs/${name}.svg`

export const shalvaBlocks = [
	{ component: EventNav, thumbnail: thumb('EventNav') },
	{ component: EventHero, thumbnail: thumb('EventHero') },
	{ component: EventAbout, thumbnail: thumb('EventAbout') },
	{ component: EventFooter, thumbnail: thumb('EventFooter') },
	{ component: EventPeople, thumbnail: thumb('EventFeaturing') },
	{ component: EventNames, thumbnail: thumb('EventNames') },
	{ component: EventMedia, thumbnail: thumb('EventMedia') },
	{ component: EventGallery, thumbnail: thumb('EventMedia') },
	{ component: EventJournal, thumbnail: thumb('EventJournal') },
	{ component: EventRegistration, thumbnail: thumb('EventRegistration') },
	{ component: Spacer, thumbnail: thumb('Spacer') },
]
